<div class="vertical-tabs">
  @for (tab of tabs; track tab.route) {
    <a
      [routerLink]="tab.route"
      routerLinkActive="active"
      class="tab-button"
    >
      <p>{{ tab.label | translate }}</p>
    </a>
  }
</div>
